/**
 * A flag to override the URL for the ODSP Driver Manifest
 */
export const fluidOdspDriverManifestUrl = 'fluidOdspDriverManifestUrl';
